import DepartmentsFilter from './DepartmentsFilter';
export default DepartmentsFilter;
